// extracted by mini-css-extract-plugin
export default {"promocode_container":"Promocode_promocode_container__ASu1b"};